import {
  ApiPlatform,
  ApiSignupAuthResponse,
  ApiSignupRequest,
  OnboardingServiceSignupAuthServiceEnum,
  OnboardingServiceSignupAuthUrlServiceEnum,
} from "@incendium/api";
import { loginSuccess, setUser } from "Actions";
import { reinitializeApiServices, userService } from "Apis/api";
import { onboardingService } from "Apis";
import { saveAuthToken } from "Helpers/saveAuthToken";
import { AuthTokens } from "Types/auth";
import { Dispatch } from "redux";
import { getDomainEnvironment } from "features/auth/utils";

export const signup = async (request: ApiSignupRequest) => {
  await onboardingService.onboardingServiceSignup({
    body: request,
  });
};

export const wooCommerceSignup = async ({
  email,
  name,
  storeUrl,
  phoneNumber,
}: {
  email: string;
  name: string;
  storeUrl: string;
  phoneNumber?: string;
}) => {
  await signup({
    email,
    name,
    storeUrl,
    platform: ApiPlatform.PLATFORM_WOOCOMMERCE,
    phoneNumber,
  });
};

export const socialAuthUrl = async ({
  service,
  redirectUrl,
}: {
  service: OnboardingServiceSignupAuthServiceEnum;
  redirectUrl: string;
}) => {
  return onboardingService.onboardingServiceSignupAuthUrl({
    service: service as unknown as OnboardingServiceSignupAuthUrlServiceEnum,
    redirectUrl,
  });
};

export const socialAuth = async ({
  service,
  code,
  redirectUrl,
  storeUrl,
  platform,
  shop,
}: {
  service: OnboardingServiceSignupAuthServiceEnum;
  code: string;
  redirectUrl?: string;
  storeUrl?: string;
  platform?: ApiPlatform;
  shop?: string;
}): Promise<ApiSignupAuthResponse> => {
  return onboardingService.onboardingServiceSignupAuth({
    service,
    payload: {
      code,
      redirectUrl,
      storeUrl,
      platform,
      shop,
    },
  });
};

export const wooCommerceSocialSignupAuthUrl = socialAuthUrl;

export const wooCommerceSocialSignup = async ({
  service,
  code,
  storeUrl,
  redirectUrl,
}: {
  service: OnboardingServiceSignupAuthServiceEnum;
  code: string;
  storeUrl: string;
  redirectUrl: string;
}): Promise<ApiSignupAuthResponse> => {
  return socialAuth({
    service,
    code,
    redirectUrl,
    storeUrl,
    platform: ApiPlatform.PLATFORM_WOOCOMMERCE,
  });
};

export const socialLogin = async ({
  service,
  code,
  redirectUrl,
}: {
  service: OnboardingServiceSignupAuthServiceEnum;
  code: string;
  redirectUrl?: string;
}): Promise<ApiSignupAuthResponse> => {
  return socialAuth({
    service,
    code,
    redirectUrl,
  });
};

export const loginWithSignupAuthResponse = async (
  response: ApiSignupAuthResponse,
  dispatch: Dispatch,
): Promise<AuthTokens> => {
  if (!response.token) {
    throw new Error("Missing auth token");
  }
  // Select first environment for now (supporting only 1 env per user)
  // try match enviroments based on the domain
  let selectedEnv = getDomainEnvironment(response.envs || []);

  const tokens: AuthTokens = {
    token: response.token,
    refresh_token: response.refreshToken,
    selectedEnv,
    envs: response.envs,
  };

  saveAuthToken(tokens);
  reinitializeApiServices();

  const user = await userService.userServiceGetAuthUser();
  dispatch(setUser(user));
  dispatch(loginSuccess(tokens));

  return tokens;
};
